export const ANTI_FRAUD_STRINGS = {
	TEXT_BOLD: 'Não compartilhe senhas e códigos',
	TEXT_SUFFIX: 'de acesso com terceiros. Utilize esses dados APENAS para acessar sua conta no site ou aplicativo da Webmotors.',
} as const;

export const STORE_NAME = 'WMGarageData' as const;

export const STORE_PROPERTIES = {
	hideAntiFraudMessage: 'hideAntiFraud',
	editedPhoneDate: 'editedPhoneDate',
} as const;
